import { createContext } from "react";
export const BasketContext = createContext(null)
